import React from 'react';
import Banner from '../components/Banner';
import LinksInfo from '../components/LinksInfo';
import Footer from '../components/Footer';

const PartnersPage: React.FC = () => {
  return (
    <div>
      <Banner />
      <LinksInfo />
      <Footer />
    </div>
  );
};

export default PartnersPage;
